// extracted by mini-css-extract-plugin
export var contentBody = "_5v-9";
export var headerImage = "_5v-2";
export var imageButton = "_5v-7";
export var imageButtonIcon = "_5v-8";
export var imageHeader = "_5v-4";
export var imageHeaderText = "_5v-5";
export var imageOverlay = "_5v-3";
export var imageTitle = "_5v-6";
export var imageWrapper = "_5v-1";
export var taskList = "_5v-a";
export var widget = "_5v-0";